import React, { useState } from "react";
import AppFormik from "src/commun/composants/formulaire/formik/AppFormik";
import { FormikValues } from "formik";
import { GenericApiResponse } from "src/app/api/AppApiClient";
import CodeTelephoneCheckFormContent from "src/pages/finalisation/etapes/verificationTelephone/codeTelephoneCheck/CodeTelephoneCheckFormContent";
import useValidationSchemaTelephoneCode, { CheckTelephoneCode } from "src/pages/finalisation/etapes/verificationTelephone/codeTelephoneCheck/useValidationSchemaTelephoneCode";
import { AxiosError } from "axios";

export type VerificationTelephoneFormProps = {
  initialValues: CheckTelephoneCode;
  stepPrecedente: () => void;
  pageSuivante?: (data: any) => void;
  canSkip?: boolean;
  submitSuccessHandler: (result: GenericApiResponse<any>, values: FormikValues) => void;
  submitFormAPI: (values: CheckTelephoneCode) => Promise<void>;
  displayCancelBtn?: boolean;
  cancelCallback?: () => void;
};


const CodeTelephoneCheckForm = ({ initialValues, stepPrecedente, pageSuivante, submitSuccessHandler, submitFormAPI, canSkip, displayCancelBtn, cancelCallback }: VerificationTelephoneFormProps) => {
  const validationSchema = useValidationSchemaTelephoneCode();
  const [customError, setCustomError] = useState<AxiosError | undefined>();

  const handleCustomError = (err: AxiosError | undefined) => {
    setCustomError(err);
  }

  return (
    <AppFormik
      enableReinitialize
      initialValues={initialValues}
      submitFormAPI={submitFormAPI}
      submitSuccessHandler={submitSuccessHandler}
      validationSchema={validationSchema}
      customError={customError}
    >
      <CodeTelephoneCheckFormContent
        stepPrecedente={stepPrecedente}
        pageSuivante={pageSuivante}
        canSkip={canSkip}
        setCustomError={handleCustomError}
        displayCancelBtn={displayCancelBtn}
        cancelCallback={cancelCallback}
      />
    </AppFormik>
  );
};

export default CodeTelephoneCheckForm;